/* eslint-disable consistent-return */
/* eslint-disable no-return-await */
import React from 'react';
import Socket from './hooks/socket';
import Route from './routes/index';

export default function App() {
  Socket();
  return <Route />;
}
